import { ScrollTextIcon } from '@/components/atoms/icons';
import { WebAccordion } from '@/components/molecules';
import { UnitDocumentItem } from '@/modules/properties-web/components/UnitDocumentItem';
import React from 'react';
import { StyleSheet, View } from 'react-native';
import type {
  GuestDetailsLayout,
  GuestDetailsTypeScale,
} from '../constants/guestLayout';
import type { GuestLabels } from '../constants/getGuestLabels';
import { getGuestWebAccordionFrame } from '../details/guestDetailsAccordionPad';
import type { GuestUnitDocument } from '../types/guest.types';

export interface GuestUnitDocumentsAccordionProps {
  readonly documents: ReadonlyArray<GuestUnitDocument>;
  readonly layout: GuestDetailsLayout;
  readonly typeScale: GuestDetailsTypeScale;
  readonly labels: GuestLabels;
  readonly onDocumentPress: (documentId: string) => void;
  readonly downloadingDocumentId?: string | null;
}

/** Documents — Contentful brochure; hidden when `documents` is empty. Guest-only accordion UI. */
export function GuestUnitDocumentsAccordion({
  documents,
  layout,
  typeScale,
  labels,
  onDocumentPress,
  downloadingDocumentId = null,
}: Readonly<GuestUnitDocumentsAccordionProps>) {
  if (documents.length === 0) {
    return null;
  }

  const frame = getGuestWebAccordionFrame(layout);

  return (
    <WebAccordion
      icon={ScrollTextIcon}
      title={labels.documents}
      variant="large"
      defaultExpanded
      titleVariant={typeScale.accordionTitle}
      sectionGap={0}
      {...frame}
    >
      <View style={styles.documentsList}>
        {documents.map((document) => (
          <UnitDocumentItem
            key={document.id}
            title={document.title}
            isDownloading={downloadingDocumentId === document.id}
            onPress={() => onDocumentPress(document.id)}
          />
        ))}
      </View>
    </WebAccordion>
  );
}

const styles = StyleSheet.create({
  documentsList: {
    gap: 8,
  },
});

export default GuestUnitDocumentsAccordion;
